import angular from 'angular';
import angularMessages from 'angular-messages';
import angularRoute from 'angular-route';

import ApplicationService from './services/ApplicationService';

import AgencyInformationController from './controllers/AgencyInformationController';
import GetStartedController from './controllers/GetStartedController';
import UpdatePayPacketController from './controllers/UpdatePayPacketController';
import UpdatePayPacketInformationController from './controllers/UpdatePayPacketInformationController';
import BrokerInformationController from './controllers/BrokerInformationController';
import CommissionAssignmentController from './controllers/CommissionAssignmentController';
import ProducerDeclarationsController from './controllers/ProducerDeclarationsController';
import ReviewController from './controllers/ReviewController';
import ThankYouController from './controllers/ThankYouController';

import actionsDirective from './directives/actionsDirective';
import angularMaskDirective from './directives/angularMaskDirective';
import addressValidatorDirective from './directives/addressValidatorDirective';

import birthdayPickerDirective from './directives/birthdayPickerDirective';
import datePickerDirective from './directives/datePickerDirective';
import ssnDirective from './directives/ssnDirective';

import getStartedTemplate from '../partials/get-started.pug';
import updatePayPacketTemplate from '../partials/update-pay-packet.pug';
import updatePayPacketInformationTemplate from '../partials/update-pay-packet-information.pug';
import brokerInformationTemplate from '../partials/broker-information.pug';
import agencyInformationTemplate from '../partials/agency-information.pug';
import commissionAssignmentTemplate from '../partials/commission-assignment.pug';
import producerDeclarationTemplate from '../partials/producer-declaration.pug';
import ThankYouTemplate from '../partials/thank-you.pug';
import reviewTemplate from '../partials/review.pug';

import '../sass/main.sass';

var direct = true;

angular
  .module('app', [ angularRoute, angularMessages ])
  .controller('GetStartedController', GetStartedController)
  .controller('UpdatePayPacketController', UpdatePayPacketController)
  .controller('UpdatePayPacketInformationController', UpdatePayPacketInformationController)
  .controller('BrokerInformationController', BrokerInformationController)
  .controller('AgencyInformationController', AgencyInformationController)
  .controller('CommissionAssignmentController', CommissionAssignmentController)
  .controller('ProducerDeclarationsController', ProducerDeclarationsController)
  .controller('ReviewController', ReviewController)
  .controller('ThankYouController', ThankYouController)
  .service('ApplicationService', ApplicationService)
  .directive('actions', [ actionsDirective ])
  .directive('datePicker', [datePickerDirective])
  .directive('birthdayPicker', [ birthdayPickerDirective ])
  .directive('ssn', [ ssnDirective ])
  .directive('angularMask', angularMaskDirective)
  .directive('addressValidator', [ addressValidatorDirective ])
  .config(['$routeProvider', '$locationProvider', '$compileProvider', function ($routeProvider, $locationProvider, $compileProvider) {
    // Explicitly saying NO to pushState as it would not be supported on BE side
    $locationProvider.html5Mode(false);
    $compileProvider.debugInfoEnabled(false);
    $routeProvider
      .when('/application/get-started', {
        controller: 'GetStartedController',
        template: getStartedTemplate
      })
      .when('/application/update-pay-packet', {
        controller: 'UpdatePayPacketController',
        template: updatePayPacketTemplate
      })
      .when('/application/update-pay-packet/information', {
        controller: 'UpdatePayPacketInformationController',
        template: updatePayPacketInformationTemplate
      })
      .when('/application/broker-information', {
        controller: 'BrokerInformationController',
        template: brokerInformationTemplate
      })
      .when('/application/agency-information', {
        controller: 'AgencyInformationController',
        template: agencyInformationTemplate
      })
      .when('/application/commission-assignment', {
        controller: 'CommissionAssignmentController',
        template: commissionAssignmentTemplate
      })
      .when('/application/producer-declaration', {
        controller: 'ProducerDeclarationsController',
        template: producerDeclarationTemplate
      })
      .when('/application/review/:subRoute?', {
        controller: 'ReviewController',
        template: reviewTemplate
      })
      .when('/application/update-pay-packet/review/:subRoute?', {
        controller: 'ReviewController',
        template: reviewTemplate
      })
      .when('/application/thank-you', {
        controller: 'ThankYouController',
        template: ThankYouTemplate
      })
      .when('/application/update-pay-packet/thank-you', {
        controller: 'ThankYouController',
        template: ThankYouTemplate
      })
      .otherwise({
        redirectTo: '/application/get-started'
      });
  }])
  .run(['$rootScope', '$window', '$location', function ($rootScope, $window, $location) {
    $rootScope.$on('$locationChangeStart', function (event, next, current) {
      // very very basic validation to make sure steps aren't skipped
      if ($location.path() !== '/application/get-started' &&
          $location.path() !== '/application/update-pay-packet' &&
          direct) {
        if ($location.path().indexOf('update-pay-packet') > -1) {
          $location.path('/application/update-pay-packet');
        } else {
          $location.path('/application/get-started');
        }
        return;
      }
      $window.scrollTo(0, 0);
      direct = false;
    });
  }]);



//////////////////
// WEBPACK FOOTER
// ./src/js/app.js
// module id = 49
// module chunks = 0